import { z } from 'zod'

const MAX_BLOB_PROBLEM_BYTES = 64 * 1024

const JSON_PROBLEM_MIME = /^application\/(?:problem\+)?json(?:\s*;.*)?$/iu

const blobFailureSchema = z.looseObject({
  response: z.looseObject({
    _data: z
      .instanceof(Blob)
      .refine((blob) => JSON_PROBLEM_MIME.test(blob.type) && blob.size <= MAX_BLOB_PROBLEM_BYTES)
  })
})

/**
 * A failed response requested with `responseType: 'blob'` carries its body as
 * a Blob, which AppProblemModel cannot read. Returns the JSON the Blob holds
 * when it is typed application/json or application/problem+json and at most
 * MAX_BLOB_PROBLEM_BYTES; any other failure, or a body that is not JSON, is
 * returned unchanged.
 */
export const decodeBlobProblem = async (failure: unknown): Promise<unknown> => {
  const blobFailure = blobFailureSchema.safeParse(failure)
  if (blobFailure.success) {
    try {
      return JSON.parse(await blobFailure.data.response._data.text())
    } catch {
      return failure
    }
  }
  return failure
}
